import(/* webpackMode: "eager", webpackExports: ["ForumBoardClient"] */ "/workspace/web/platform/forum/ForumBoardClient.tsx");
